import { ClientType, bridge } from '@/lib/bridge';

export const usePlatform = () => {
  const isAndroid = bridge.clientType === ClientType.Android;
  const isWeb = bridge.clientType === ClientType.Web;
  const isIOS = bridge.clientType === ClientType.iOS;
  const platform = bridge.clientType;

  return {
    isAndroid,
    isIOS,
    isWeb,
    platform,
  };
};
